import {ChangePage, init, PaginationState, setPage, setPageSize} from './paginationSlice'
import * as React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {PAGE, PAGE_SIZE} from "../../../utils/constants.ts";

const composeSearchParams = function (searchParams: URLSearchParams, page: number, pageSize: number) {
  let changes = false
  if (searchParams.has('page')) {
    searchParams.set('page', page.toString())
    changes = true
  } else if (page != PAGE) {
    searchParams.append('page', page.toString())
    changes = true
  }
  if (searchParams.has('pageSize')) {
    searchParams.set('pageSize', pageSize.toString())
    changes = true
  } else if (pageSize != PAGE_SIZE) {
    searchParams.append('pageSize', pageSize.toString())
    changes = true
  }
  if (changes) {
    window.history.pushState({}, '', '?' + searchParams.toString())
  }
}

export default function usePagination(pageName: string) {

  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(window.location.search)

  const state: PaginationState = useSelector((state: { pagination: any }) => state.pagination)

  const page = Number(state.changed ? (state.page) : (searchParams.get('page') ?? state.page))
  const pageSize = Number(state.changed ? (state.pageSize) : (searchParams.get('pageSize') ?? state.pageSize))

  const handleChangePage = React.useCallback((page: number) => {
    dispatch(setPage({page, pageName}))
  }, [dispatch, pageName])

  const handleChangePageSize = React.useCallback((pageSize: number) => {
    dispatch(setPageSize({pageSize, pageName}))
  }, [dispatch, pageName])

  React.useEffect(() => {
    if (!state.changed) {
      dispatch(init({page, pageSize, pageName}))
    }
    composeSearchParams(searchParams, page, pageSize)
  }, [page, pageSize])

  React.useEffect(() => {
    if (state.changed) {
      dispatch(init({page: 0, pageSize, pageName}))
    }
  }, [pageName])

  return {page, pageSize, handleChangePage, handleChangePageSize}
}
